"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageClient = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./models/index.js"), exports);
var storageClient_js_1 = require("./storageClient.js");
Object.defineProperty(exports, "StorageClient", { enumerable: true, get: function () { return storageClient_js_1.StorageClient; } });
tslib_1.__exportStar(require("./operationsInterfaces/index.js"), exports);
//# sourceMappingURL=index.js.map